var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33342 10.9166H8.58342V11.6666V15.8333C8.58342 15.8539 8.57567 15.8741 8.55829 15.8915C8.54092 15.9089 8.52067 15.9166 8.50008 15.9166H5.00008C4.9795 15.9166 4.95925 15.9089 4.94187 15.8915C4.92449 15.8741 4.91675 15.8539 4.91675 15.8333V9.99998V9.24998H4.16675H3.62348L9.94184 3.55891C9.94199 3.55878 9.94213 3.55865 9.94228 3.55852C9.97411 3.53046 10.0261 3.53046 10.0579 3.55852C10.058 3.55865 10.0582 3.55878 10.0583 3.55891L16.3767 9.24998H15.8334H15.0834V9.99998V15.8333C15.0834 15.8539 15.0757 15.8741 15.0583 15.8915C15.0409 15.9089 15.0207 15.9166 15.0001 15.9166H11.5001C11.4795 15.9166 11.4592 15.9089 11.4419 15.8915C11.4245 15.8741 11.4167 15.8539 11.4167 15.8333V11.6666V10.9166H10.6667H9.33342Z",
    stroke: "current",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "97120/static/media/Home.a77e4af1d0e4aecf185b5dc9c1f24b49.svg";
export { ForwardRef as ReactComponent };